const getExtension = filename => {
  const filenameSplit = filename.split('.');
  
  return filenameSplit[filenameSplit.length - 1];
};

export default getExtension;
